export default __webpack_public_path__ + "static/media/profile-img.f69350d9.png";